import { Component, OnInit } from '@angular/core';

import { FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
//VAlidaciones
import { NgxSpinnerModule, NgxSpinnerService } from 'ngx-spinner';
import { BaseDto } from '@models/base/baseDto.model';
import { isFalsy } from 'utility-types';
import { EstadoExpedientePeritoService } from '@services/estadoExpedientePerito/estadoExpedientePerito.service';
import { TipoExpedienteService } from '@services/tipoExpediente/tipoExpediente.service';
import { EstadoExpedienteService } from '@services/estadoExpediente/estadoExpediente.service';
import { ExpedienteService } from '@services/expediente/expediente.service';
import { JuzgadoService } from '@services/juzgado/juzgado.service';
import { JuzgadoDto } from '@models/juzgado/juzgadoDto.model';
import { ExpedienteDto } from '@models/expediente/expedienteDto.model';
import { UpdateExpedienteRequest } from '@models/expediente/updateExpedienteRequest.model';
import { EstadoProcesalService } from '@services/estadoProcesal/estado-procesal.service';
import { CasoDto } from '@models/caso/casoDto.model';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatNativeDateModule, MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AppRolesDirective } from '@directives/appRoles/app-roles.directive';
import { GoBackAndTitleComponent } from 'src/app/component/go-back-and-title/go-back-and-title.component';

import { ButtonSaveComponent } from 'src/app/component/button-save/button-save.component';
import { ButtonCancelComponent } from 'src/app/component/button-cancel/button-cancel.component';

@Component({
  standalone: true,
  imports: [MatFormFieldModule, MatCardModule, MatIconModule, MatButtonModule, MatDividerModule, NgxSpinnerModule, MatTableModule, MatSliderModule, MatSlideToggleModule, MatMenuModule, MatDialogModule, MatDatepickerModule, MatExpansionModule, MatRadioModule, MatSelectModule,   MatInputModule, MatButtonModule, CommonModule, FormsModule, MatSortModule, ReactiveFormsModule,  MatTooltipModule, MatPaginatorModule, MatRippleModule,GoBackAndTitleComponent,MatCardModule,MatNativeDateModule,AppRolesDirective,ButtonSaveComponent,ButtonCancelComponent  ],
  selector: 'app-form-expediente-update',
  templateUrl: './form-expediente-update.component.html',
  styleUrls: ['./form-expediente-update.component.css'],

})
export class FormExpedienteUpdateComponent {

  expedienteDto!: ExpedienteDto
  formBuilder: FormBuilder = new FormBuilder;
  estadosExpedientes!: BaseDto[];
  estadosExpedientesPerito!: BaseDto[];
  expedienteForm!: FormGroup;
  tiposExpedientes!: BaseDto[];
  juzgados!: JuzgadoDto[];
  estadosProcesal!: BaseDto[];
  get f() { return this.expedienteForm.controls; }

  constructor(
    private ExpedienteService: ExpedienteService,
    private TipoExpedienteService: TipoExpedienteService,
    private EstadoExpedienteService: EstadoExpedienteService,
    private JuzgadoService: JuzgadoService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private snackBar: SnackBarService,
    private EstadoExpedientePeritoService: EstadoExpedientePeritoService,
    private spinner: NgxSpinnerService,
    private estadoProcesalService: EstadoProcesalService

  ) { }

  ngOnInit(): void {
    let idExpediente = this.activatedRoute.snapshot.params['id']
    this.getAllEstadosExpediente();
    this.getAllEstadosExpedientePerito();
    this.getAllTiposExpedientes();
    this.getAllJuzgados()
    this.getAllEstadosProcesal();
    this.getExpedienteById(idExpediente)
    this.expedienteForm = this.formBuilder.group({
      Descripcion: [''],
      Ubicacion: [''],
      Caratula: ["", Validators.compose([Validators.required, Validators.maxLength(200)])],
      IdentificadorUnico: ['', Validators.compose([Validators.required, , Validators.maxLength(50)])],
      Numero: [''],
      Demanda: [''],
      Causa: [''],
      TipoExpediente: [''],
      Demandado: [''],
      EstadoExpedientes: [''],
      EstadoProcesal: [''],
      EstadoExpedientesPerito: [''],
      Juzgado: ['', Validators.compose([Validators.required])],
      ClaveExpediente: [''],
      Sufijo: [''],
      Bis: [''],
      FechaIngresoMEU: [''],
      MontoDemanda: [''],
    });
  }

  onSubmit() {
    if (this.expedienteForm.invalid) {
      return;
    }
    const updateExpedienteRequest: UpdateExpedienteRequest = this.setUpdateExpedienteRequest();
    this.spinner.show("spExpediente")
    this.ExpedienteService.update(updateExpedienteRequest)
      .subscribe(
        data => {
          this.spinner.hide("spExpediente")
          this.snackBar.showSuccess("Se modifico el registro correctamente.", "Exito");
          this.router.navigate(["/expedientes/" + updateExpedienteRequest.id])
        },
        error => {
          this.spinner.hide("spExpediente")
          this.snackBar.showError(error, "Error");
        })
  }

  getExpedienteById(id: number) {
    this.spinner.show("spExpediente")
    this.ExpedienteService.getById(id)
      .subscribe(
        data => {
          this.spinner.hide("spExpediente")
          this.expedienteDto = data
          this.setExpedienteDtoForm(data);
          this.ExpedienteService.setExpedienteDto(data)
        },
        error => {
          this.spinner.hide("spExpediente")
          this.snackBar.showError(error, "Error");
        })
  }

  setExpedienteDtoForm(expedienteDto: ExpedienteDto) {
    this.expedienteForm.controls['Descripcion'].setValue(expedienteDto.descripcion);
    this.expedienteForm.controls['Ubicacion'].setValue(expedienteDto.ubicacion);
    this.expedienteForm.controls['Caratula'].setValue(expedienteDto.caratula);
    this.expedienteForm.controls['IdentificadorUnico'].setValue(expedienteDto.identificadorUnico);
    this.expedienteForm.controls['Numero'].setValue(expedienteDto.numero);
    this.expedienteForm.controls['Demanda'].setValue(expedienteDto.demanda);
    this.expedienteForm.controls['Causa'].setValue(expedienteDto.causa);
    this.expedienteForm.controls['TipoExpediente'].setValue(expedienteDto.tipoExpediente == undefined ? null : expedienteDto.tipoExpediente.id);
    this.expedienteForm.controls['Demandado'].setValue(expedienteDto.demandado);
    this.expedienteForm.controls['EstadoExpedientes'].setValue(expedienteDto.estadoExpediente == undefined ? null : expedienteDto.estadoExpediente.id);
    this.expedienteForm.controls['Juzgado'].setValue(expedienteDto.juzgado == undefined ? null : expedienteDto.juzgado.id);
    this.expedienteForm.controls['ClaveExpediente'].setValue(expedienteDto.claveExpediente);
    this.expedienteForm.controls['Sufijo'].setValue(expedienteDto.sufijo);
    this.expedienteForm.controls['Bis'].setValue(expedienteDto.bis);
    this.expedienteForm.controls['FechaIngresoMEU'].setValue(expedienteDto.fechaIngresoMEU);
    this.expedienteForm.controls['MontoDemanda'].setValue(expedienteDto.montoDemanda);
    this.expedienteForm.controls['EstadoProcesal'].setValue(expedienteDto.estadoProcesal == undefined ? null : expedienteDto.estadoProcesal.id);
  }

  getAllEstadosExpediente() {
    this.spinner.show("spEstadosExpediente")
    this.EstadoExpedienteService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spEstadosExpediente")
          this.estadosExpedientes = data
        },
        error => {
          this.spinner.hide("spEstadosExpediente")
          this.snackBar.showError(error, "Error");
        })
  }

  getAllEstadosProcesal() {
    this.spinner.show("spEstadosProcesal")
    this.estadoProcesalService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spEstadosProcesal")
          this.estadosProcesal = data
        },
        error => {
          this.spinner.hide("spEstadosProcesal")
          this.snackBar.showError(error, "Error");
        })
  }

  getAllEstadosExpedientePerito() {
    this.spinner.show("spEstadosExpedientePerito")
    this.EstadoExpedientePeritoService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spEstadosExpedientePerito")
          this.estadosExpedientesPerito = data
        },
        error => {
          this.spinner.hide("spEstadosExpedientePerito")
          this.snackBar.showError(error, "Error");
        })
  }

  getAllTiposExpedientes() {
    this.spinner.show("spTiposExpediente")
    this.TipoExpedienteService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spTiposExpediente")
          this.tiposExpedientes = data
        },
        error => {
          this.spinner.hide("spTiposExpediente")
          this.snackBar.showError(error, "Error");
        })
  }

  getAllJuzgados() {
    this.spinner.show("spJuzgados")
    this.JuzgadoService.getAll()
      .subscribe(
        data => {
          this.spinner.hide("spJuzgados")
          this.juzgados = data
        },
        error => {
          this.spinner.hide("spJuzgados")
          this.snackBar.showError(error, "Error");
        })
  }

  setUpdateExpedienteRequest(): UpdateExpedienteRequest {

    const updateExpedienteRequest = new UpdateExpedienteRequest();

    updateExpedienteRequest.id = this.expedienteDto.id
    updateExpedienteRequest.idCaso = this.expedienteDto.caso.id;
    updateExpedienteRequest.idEstadoProcesal = isFalsy(this.expedienteForm.controls['EstadoProcesal'].value) ? null : this.expedienteForm.controls['EstadoProcesal'].value;
    updateExpedienteRequest.descripcion = this.expedienteForm.controls['Descripcion'].value;
    updateExpedienteRequest.ubicacion = this.expedienteForm.controls['Ubicacion'].value;
    updateExpedienteRequest.caratula = this.expedienteForm.controls['Caratula'].value;
    updateExpedienteRequest.identificadorUnico = this.expedienteForm.controls['IdentificadorUnico'].value;
    updateExpedienteRequest.numero = this.expedienteForm.controls['Numero'].value;
    updateExpedienteRequest.demanda = this.expedienteForm.controls['Demanda'].value;
    updateExpedienteRequest.idTipoExpediente = isFalsy(this.expedienteForm.controls['TipoExpediente'].value) ? null : this.expedienteForm.controls['TipoExpediente'].value;
    updateExpedienteRequest.demandado = this.expedienteForm.controls['Demandado'].value;
    updateExpedienteRequest.causa = this.expedienteForm.controls['Causa'].value;
    updateExpedienteRequest.idEstadoExpediente = isFalsy(this.expedienteForm.controls['EstadoExpedientes'].value) ? null : this.expedienteForm.controls['EstadoExpedientes'].value;
    updateExpedienteRequest.idJuzgado = isFalsy(this.expedienteForm.controls['Juzgado'].value) ? null : this.expedienteForm.controls['Juzgado'].value;
    updateExpedienteRequest.claveExpediente = this.expedienteForm.controls['ClaveExpediente'].value;
    updateExpedienteRequest.sufijo = this.expedienteForm.controls['Sufijo'].value;
    updateExpedienteRequest.bis = this.expedienteForm.controls['Bis'].value;
    updateExpedienteRequest.fechaIngresoMEU = this.expedienteForm.controls['FechaIngresoMEU'].value;
    updateExpedienteRequest.montoDemanda = isFalsy(this.expedienteForm.controls['MontoDemanda'].value) ? 0 : this.
      expedienteForm.controls['MontoDemanda'].value;
    return updateExpedienteRequest
  }

  onReset() {
    this.expedienteForm.reset();
  }

  isFalsy(valor: any) {
    return isFalsy(valor)
  }

  trackByItems(index: number, item: any): any { return item; }
}

